import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components";

import { SalesforceFieldMappingPanel } from "./SalesforceFieldMappingPanel";

interface SalesforceFieldMappingModalProps {
	isOpen: boolean;
	onClose: () => void;
}

/**
 * The field-mapping panel in a dialog, for the "Configure Field Mapping" button on the
 * connection tab. The settings shell renders the same panel as its own FIELD_MAPPING tab —
 * one implementation, two entry points, so the two can never drift.
 */
export const SalesforceFieldMappingModal: FunctionComponent<SalesforceFieldMappingModalProps> = ({
	isOpen,
	onClose,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			handleClose={onClose}
			isOpened={isOpen}
			size="lg"
			title={t("company.salesforce.fieldMapping.title")}
		>
			<SalesforceFieldMappingPanel />
		</Modal>
	);
};
